import React, { Component } from "react";
import List from "./BankLedgerList";
import AddEdit from "./BankLedgerAddEdit";

export default class BankLedger extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mode: "List",
      data: null,
      bank: ""
    };
    this.handleClick = this.handleClick.bind(this);
  }
  render() {
    if (this.state.mode === "List") {
      return <List onClick={this.handleClick} />;
    } else {
      return (
        <AddEdit
          pData={this.state.data}
          onClick={this.handleClick}
          source="list"
          bank={this.state.bank}
        />
      );
    }
  }

  handleClick(mode, data, bank) {
    this.setState({ data, mode, bank });
  }
}
